export enum HccId {
    MAHCC_V24_2022_Final = 35,
    MAHCC_V22_DOS_2017 = 2,
    MAHCC_V23_DOS_2018 = 20,
    MAHCC_V24_DOS_2019 = 21,
    MAHCC_V24_2023 = 38,
    MAHCC_V24 = 44,
    MAHCC_V28 = 45,
}
